var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import classnames from "classnames";
import { IconCheckmark, IconClose, IconCloseCircle } from "../../icons";
export var Progress = function (props) {
    var _a, _b, _c;
    var _d = props.status, status = _d === void 0 ? "success" : _d, _e = props.type, type = _e === void 0 ? "line" : _e, _f = props.className, className = _f === void 0 ? "" : _f, percent = props.percent, _g = props.showInfo, showInfo = _g === void 0 ? true : _g, _h = props.active, active = _h === void 0 ? false : _h, width = props.width;
    var classNames = classnames((_a = {},
        _a["mex-progress__wrapper"] = true,
        _a[className] = className,
        _a));
    var circleClassNames = classnames((_b = {},
        _b["mex-progress-circle"] = true,
        _b["over50"] = percent > 50,
        _b["mex-progress-circle__p--".concat(percent)] = true,
        _b));
    var overrideStatus = percent === 100 ? "completed" : active ? "active" : status;
    var percentage = percent + "%";
    var content;
    switch (overrideStatus) {
        case "exception":
            content =
                type === "circle" ? (_jsx(IconClose, { className: "mex-progress__color--exception" })) : (_jsx(IconCloseCircle, { className: "mex-progress__color--exception" }));
            break;
        case "completed":
            content = _jsx(IconCheckmark, { className: "mex-progress__color--completed" });
            break;
        default:
            content = _jsx("span", { children: percentage });
            break;
    }
    if (type === "circle") {
        return (_jsxs("div", __assign({ className: circleClassNames, style: { fontSize: width ? width / 5 : 20 } }, { children: [content, _jsxs("div", __assign({ className: "mex-progress-circle__left-half-clipper" }, { children: [_jsx("div", { className: "mex-progress-circle__first50-bar mex-progress-circle__status--".concat(overrideStatus) }), _jsx("div", { className: "mex-progress-circle__value-bar mex-progress-circle__status--".concat(overrideStatus) })] }))] })));
    }
    var linerClassNames = classnames((_c = {},
        _c["mex-progress-line_liner"] = true,
        _c["mex-progress-line__status--".concat(overrideStatus)] = true,
        _c));
    return (_jsxs("div", __assign({ className: classNames, style: { width: width ? width : "100%" } }, { children: [_jsx("div", __assign({ className: "mex-progress-line__container" }, { children: _jsx("div", { className: linerClassNames, style: { width: percentage } }) })), showInfo && _jsx("div", __assign({ className: "mex-progress-line__info" }, { children: content }))] })));
};
Progress.propTypes = {
    status: PropTypes.oneOf(["success", "exception", "active"]),
    className: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.oneOf(["line", "circle"]),
    showInfo: PropTypes.bool,
    active: PropTypes.bool,
};
Progress.defaultProps = {
    status: "success",
    type: "line",
};
export default Progress;
